/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import Sandbox from '../Sandbox';
import _ from 'underscore';
export default {
    /**
         * @memberof  factory:sandboxFactory
         * @param {string|number} key - sandbox instance key. Used for cache.
         * @desc gets Sandbox instance by given key.
         * @returns {Sandbox} - new Sandbox instance. If key was not passed, returns null.
         */
    get: _.memoize(function (key) {
        if (!key) {
            return null;
        }
        return new Sandbox();
    })
};